import { useEffect, useState } from "react";

export function useDynastyViewport(options: { backgroundColor?: string } = {}) {
  const { backgroundColor = "#08111d" } = options;
  const [viewportWidth, setViewportWidth] = useState(() => {
    if (typeof window === "undefined") return 1280;
    return window.innerWidth;
  });
  const [viewportHeight, setViewportHeight] = useState(() => {
    if (typeof window === "undefined") return 900;
    return window.innerHeight;
  });
  const [isNarrowViewport, setIsNarrowViewport] = useState(() => {
    if (typeof window === "undefined") return false;
    return window.innerWidth <= 900;
  });

  useEffect(() => {
    if (typeof window === "undefined") return undefined;
    const updateViewportMode = () => {
      setViewportWidth(window.innerWidth);
      setViewportHeight(window.innerHeight);
      setIsNarrowViewport(window.innerWidth <= 900);
    };
    updateViewportMode();
    window.addEventListener("resize", updateViewportMode);
    window.addEventListener("orientationchange", updateViewportMode);
    return () => {
      window.removeEventListener("resize", updateViewportMode);
      window.removeEventListener("orientationchange", updateViewportMode);
    };
  }, []);

  useEffect(() => {
    if (typeof document === "undefined" || !isNarrowViewport) return;

    const root = document.documentElement;
    const body = document.body;
    const previousRootBackground = root.style.background;
    const previousBodyBackground = body.style.background;
    const previousRootOverscrollY = root.style.overscrollBehaviorY;
    const previousBodyOverscrollY = body.style.overscrollBehaviorY;
    const previousRootOverscrollX = root.style.overscrollBehaviorX;
    const previousBodyOverscrollX = body.style.overscrollBehaviorX;

    root.style.background = backgroundColor;
    body.style.background = backgroundColor;
    root.style.overscrollBehaviorY = "none";
    body.style.overscrollBehaviorY = "none";
    root.style.overscrollBehaviorX = "none";
    body.style.overscrollBehaviorX = "none";

    return () => {
      root.style.background = previousRootBackground;
      body.style.background = previousBodyBackground;
      root.style.overscrollBehaviorY = previousRootOverscrollY;
      body.style.overscrollBehaviorY = previousBodyOverscrollY;
      root.style.overscrollBehaviorX = previousRootOverscrollX;
      body.style.overscrollBehaviorX = previousBodyOverscrollX;
    };
  }, [backgroundColor, isNarrowViewport]);

  return {
    isNarrowViewport,
    viewportHeight,
    viewportWidth,
  };
}
